// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formSubmit {
  padding-left: 5em;
  padding-right: 5em;
  background-color: rgb(79, 81, 79) !important;
  border-color: rgb(79, 81, 79) !important;
  border-radius: 2em;
  margin: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/COMMON/BUTTON/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".formSubmit {\n  padding-left: 5em;\n  padding-right: 5em;\n  background-color: rgb(79, 81, 79) !important;\n  border-color: rgb(79, 81, 79) !important;\n  border-radius: 2em;\n  margin: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
